import React, { useCallback, useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { usePageStartBootstrap } from '../hooks/use_page_start_bootstrap';
import { processError } from '../utils/base_error';
import { useDependencyInjection } from '../../config/di/dependency_injection_context';
import { usePageLoader } from '../contexts/page_content_context';
import { DataProvisaoRecursoDropDown } from '../domain/models/data_provisao_recurso_dropdow';

type Props = {
  name: string;
  label?: string;
  newButtonLabel?: string;
  required?: boolean;
  readOnly?: boolean;
  placeholder?: string;
  disabled?: boolean;
  value: string | number | null | undefined; 
  onChange: (newValue: string | number | undefined) => void; 
  error?: boolean;
  helperText?: string | null;
};

export const DefaultDataProvisaoRecurso = ({
  name,
  label,
  required,
  readOnly,
  placeholder,
  disabled,
  value,
  onChange,
  error,
  helperText,
}: Props) => {

  const { pushErrorNotification, pushInfoNotification } = usePageLoader();
  const [dataProvisaoRecursoDropDown, setDataProvisaoRecursoDropDown] = useState<DataProvisaoRecursoDropDown[]>([]);

  const {
    commons: {
      getDataProvisaoRecursoDropDownUseCase,
    },
  } = useDependencyInjection();

  const loadFornecedorDropDown = useCallback(async () => {
    try {
      const result = await getDataProvisaoRecursoDropDownUseCase.getDataProvisaoRecursoDropDown();
      setDataProvisaoRecursoDropDown(result);
    } catch (e: unknown) {
      pushErrorNotification('Error', processError(e, 'Falha ao buscar datas Provisao Recurso!'));
    }
  }, [getDataProvisaoRecursoDropDownUseCase, pushErrorNotification]);

  usePageStartBootstrap(async () => {
    loadFornecedorDropDown();
  });


  return (
    <>
     <Autocomplete
        fullWidth={true}
        size="small"
        disablePortal
        options={dataProvisaoRecursoDropDown}
        getOptionLabel={(opt) => String(opt.data)}
        isOptionEqualToValue={(opt, val) => String(opt.data) === String(val.data)} 
        sx={{ minHeight: 45 }}
        readOnly={readOnly}
        disabled={disabled}
        value={dataProvisaoRecursoDropDown.find(x => String(x.data) === String(value)) ?? null}
        onChange={(_, newValue) => {
          onChange(newValue ? newValue.data : undefined);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            label={label}
            error={error}
            helperText={helperText}
            placeholder={placeholder}
            required={required}
          />
        )}
      />
    </>
  );
};